import { memo } from "react";
import { useNavigate } from "react-router-dom";
import WhiteMainBackground from "../../../shared_components/WhiteMainBackground/WhiteMainBackground";
import Spinner from "../../../shared_components/Spinner/Spinner";
import ListHeadingWithSearch from "../../../shared_components/ListHeadingWithSearch/ListHeadingWithSearch";
import PaginationGroup from "../../../shared_components/PaginationGroup/PaginationGroup";
import { resolveVideoId } from "../utils";
import styles from "./AnimationGrid.module.css";

function AnimationGrid({
  handleSearchSubmit,
  handleClearSearch,
  filteredAnimations,
  loading,
  currentPage,
  totalPages,
  onPageChange,
}) {
  const navigate = useNavigate();

  return (
    <WhiteMainBackground className={styles.container}>
      <div className={styles.searchContainer}>
        <ListHeadingWithSearch
          searchAction={(searchTerm) => {
            if (searchTerm === "") {
              handleClearSearch();
            } else {
              handleSearchSubmit(searchTerm);
            }
          }}
        >
          Animation Gallery
        </ListHeadingWithSearch>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <div className={styles.gridContainer}>
          {filteredAnimations.length === 0 ? (
            <p className={styles.emptyState}>No animations found.</p>
          ) : (
            filteredAnimations.map((animation, index) => {
              const animationId = resolveVideoId(animation);
              const thumbnail = animation.thumbnail_base64;

              return (
                <div
                  key={animationId || `animation-${index}`}
                  className={styles.gridItem}
                  onClick={() => animationId && navigate(`/animations/${animationId}`)}
                  role="button"
                  tabIndex={0}
                  aria-label={`Animation ${index + 1}`}
                >
                  {thumbnail ? (
                    <img
                      src={`data:image/jpeg;base64,${thumbnail}`}
                      alt={animation.assetName || `Animation ${index + 1}`}
                    />
                  ) : (
                    <div className={styles.meta}>No preview available</div>
                  )}
                </div>
              );
            }))}
        </div>
      )}

      <div className={styles.paginationContainer}>
        <PaginationGroup
          activePage={currentPage}
          numberOfPages={totalPages}
          updatePageClicked={onPageChange}
        />
      </div>
    </WhiteMainBackground>
  );
}

export default memo(AnimationGrid);
